import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConstantData } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-processing-fee',
  templateUrl: './processing-fee.component.html',
  styleUrls: ['./processing-fee.component.scss']
})
export class ProcessingFeeComponent implements OnInit {


  campspayHtml!: string;
  sanitizedCampspayHtml!: SafeHtml;
  @ViewChild('campspayIframe') campspayIframe!: ElementRef;

  ngOnInit(): void {
    this.util.cleverTapEventCall('Pay Processing fee initiated',{
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
  }

  constructor(public util: UtilService, private sanitizer: DomSanitizer) {

  }


  professingFeePopup: boolean = false;

  showFeeDialog() {
    this.professingFeePopup = true;
  }


  redirectToPaymentGateway() {
    // `${this.util.redirectUrl}pbl-customer-portal/`
    let requestData =
    {
      "loanId": this.util.loanDetails.loanId,
      "redirectUrl": `${this.util.redirectionUrl}`
    }
    this.util.handleRequests('put', this.util.getUrl('payment_session', []), requestData).then((res: any) => {
      this.campspayHtml = res.content;
      this.sanitizedCampspayHtml = this.sanitizer.bypassSecurityTrustHtml(this.campspayHtml);
    this.util.cleverTapEventCall('Pay processing fee Completed',{
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
      setTimeout(() => {
        const div = document.getElementById('paymentGateway') as HTMLFormElement;
        const form = div.querySelector('form');  
        form?.submit();
      },200);
    }).catch((error) => {
      this.util.cleverTapEventCall('Processing fee failed',{
        'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
      });
    });
  }





  back() {
    this.util.route('home');
  }


}
